import React, { useState } from "react";
import { collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import { productDb } from "../firebaseProducts";

const TagsUpdater = () => {
  const [collectionChoice, setCollectionChoice] = useState("");
  const [style, setStyle] = useState("");
  const [docsByCollection, setDocsByCollection] = useState({});
  const [newTags, setNewTags] = useState("");
  const [loading, setLoading] = useState(false);

  const collectionMap = {
    A: ["kids-accessories-menu", "full-kids-accessories"],
 B: ["kids-apparel-menu", "kids-apparel","full-kids-white","kids-apparel-white-menu"],
    C: ["adult-accessories-list-menu", "full-adult-accessories"],
     D: ["adult-list-menu", "adult-apparel"],
     E: [  "drinkwear-menu","full-drinkwear"]
  };

  const handleFetchTags = async () => {
    if (!collectionChoice || !style) {
      alert("Please select collection and enter style");
      return;
    }

    setLoading(true);
    const collectionsToCheck = collectionMap[collectionChoice] || [];
    const tempDocsByCollection = {};

    try {
      for (const colName of collectionsToCheck) {
        const q = query(collection(productDb, colName), where("Style", "==", style));
        const snap = await getDocs(q);
// snap.docs.forEach(doc => console.log(doc.id, doc.data().Style));
        const docsArray = snap.docs.map((docSnap) => {
          const data = docSnap.data();
          let tags = [];
          if (data.Tags) {
            if (Array.isArray(data.Tags)) tags = data.Tags;
            else if (typeof data.Tags === "string") tags = [data.Tags];
          }
          return { id: docSnap.id, tags };
        });

        tempDocsByCollection[colName] = docsArray;
      }

      setDocsByCollection(tempDocsByCollection);
    } catch (err) {
      console.error("Error fetching tags", err);
      alert("Error fetching tags");
    }

    setLoading(false);
  };

  const handleUpdate = async () => {
    if (!collectionChoice || !style) {
      alert("Please select collection and enter style");
      return;
    }
    if (!newTags.trim()) {
      alert("Please enter new tags");
      return;
    }

    setLoading(true);
    const collectionsToUpdate = collectionMap[collectionChoice] || [];
    const tagsArray = newTags.split(",").map((t) => t.trim()).filter(Boolean);

    try {
      for (const colName of collectionsToUpdate) {
        const q = query(collection(productDb, colName), where("Style", "==", style));
        const snap = await getDocs(q);

        for (const docSnap of snap.docs) {
          await updateDoc(docSnap.ref, { Tags: tagsArray });
        }
      }

      alert("Tags updated successfully!");
      // Update local state to reflect new tags for all collections
      const updatedDocsByCollection = {};
      collectionsToUpdate.forEach((col) => {
        updatedDocsByCollection[col] = docsByCollection[col].map((d) => ({
          ...d,
          tags: tagsArray,
        }));
      });
      setDocsByCollection(updatedDocsByCollection);
      setNewTags("");
    } catch (err) {
      console.error("Update failed", err);
      alert("Error updating tags");
    }

    setLoading(false);
  };

  return (
    <div className="p-4 max-w-lg mx-auto bg-gray-100 rounded-lg shadow">
      <h2 className="text-xl font-bold mb-4">Tag Updater</h2>

      {/* Select collection */}
      <select
        value={collectionChoice}
        onChange={(e) => setCollectionChoice(e.target.value)}
        className="w-full p-2 border mb-3"
      >
        <option value="">Select Collection</option>
        <option value="A">Kid's Accessories</option>
        <option value="B">Kid's Apparel</option>
        <option value="C">Adult's Accessories</option>
        <option value="D">Adult's Apparel</option>
        <option value="E">Drinkwear</option>
      </select>

      {/* Style input */}
      <input
        type="text"
        placeholder="Enter Style"
        value={style}
        onChange={(e) => setStyle(e.target.value)}
        className="w-full p-2 border mb-3"
      />

      {/* Fetch button */}
      <button
        onClick={handleFetchTags}
        disabled={loading}
        className="w-full bg-blue-500 text-black p-2 rounded mb-3 disabled:bg-gray-400"
      >
        {loading ? "Fetching..." : "Fetch Tags"}
      </button>

      {/* Display tags with IDs */}
      {Object.keys(docsByCollection).length > 0 && (
        <div className="mb-3 p-2 bg-white border rounded">
          <strong>Current Tags by Collection:</strong>
          {Object.entries(docsByCollection).map(([col, docs]) => (
            <div key={col} className="mt-2">
              <span className="font-semibold">{col}:</span>
              {docs.length > 0 ? (
                <ul className="list-disc ml-5 mt-1">
                  {docs.map((d) => (
                    <li key={d.id}>
                      ID: {d.id}, Tags: {d.tags.length > 0 ? d.tags.join(", ") : "No tags"}
                    </li>
                  ))}
                </ul>
              ) : (
                <div>No documents</div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* New tags input */}
      <input
        type="text"
        placeholder="Enter new tags (comma-separated)"
        value={newTags}
        onChange={(e) => setNewTags(e.target.value)}
        className="w-full p-2 border mb-3"
      />

      <button
        onClick={handleUpdate}
        disabled={loading}
        className="w-full bg-red-600 text-black p-2 rounded disabled:bg-gray-400"
      >
        {loading ? "Updating..." : "Update Tags"}
      </button>
    </div>
  );
};

export default TagsUpdater;
